import { Outlet } from "react-router";

const LabReportIndexPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default LabReportIndexPage;
